module.exports = __webpack_public_path__ + "static/media/ZSUC.b882714c.pdf";